import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

import { sdsColors } from '../theme/solutionsDesignSystem';

// A compact left-rail card — same visual language as the Solutions page's
// outcome cards, adapted for a partner audience (category eyebrow, revenue
// block instead of a plain description, "Explore the solution" link).
const useStyles = makeStyles(() => ({
    card: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        padding: '28px 28px 28px 32px',
        background: sdsColors.surface,
        border: `1px solid ${sdsColors.border}`,
        borderRadius: 16,
        overflow: 'hidden',
    },
    rail: {
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        width: 4,
    },
    category: {
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: '0.09em',
        textTransform: 'uppercase',
        color: sdsColors.textSubtle,
    },
    title: {
        margin: 0,
        fontSize: 22,
        fontWeight: 700,
        lineHeight: 1.25,
        color: sdsColors.text,
    },
    tagline: {
        margin: 0,
        fontSize: 16,
        fontWeight: 600,
        color: sdsColors.accentDark,
    },
    desc: {
        margin: 0,
        fontSize: 15,
        lineHeight: 1.55,
        color: sdsColors.textMuted,
    },
    revenueBox: {
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
        padding: '14px 16px',
        borderRadius: 10,
        background: sdsColors.bg,
    },
    revenueLabel: {
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: '0.09em',
        textTransform: 'uppercase',
        color: sdsColors.textSubtle,
    },
    revenueText: {
        fontSize: 14,
        lineHeight: 1.5,
        color: sdsColors.text,
    },
    link: {
        marginTop: 'auto',
        fontSize: 14,
        fontWeight: 600,
        color: sdsColors.accentDark,
        textDecoration: 'none',
        '&:hover': { textDecoration: 'underline' },
    },
}));

const PbdqPricingSolutionCard = ({ rail, category, title, tagline, description, bullets, to }) => {
    const classes = useStyles();

    return (
        <article className={classes.card}>
            <span className={classes.rail} style={{ background: rail }} />
            <span className={classes.category}>{category}</span>
            <h3 className={classes.title}>{title}</h3>
            <p className={classes.tagline}>{tagline}</p>
            <p className={classes.desc}>{description}</p>
            <div className={classes.revenueBox}>
                <span className={classes.revenueLabel}>Your revenue opportunities</span>
                <span className={classes.revenueText}>{bullets.join(' · ')}</span>
            </div>
            <Link to={to} className={classes.link}>Explore the solution →</Link>
        </article>
    );
};

export default PbdqPricingSolutionCard;
